import React from 'react';
import { Button } from 'components/common';
import { FaUserTimes } from 'react-icons/fa';
import { MdOutlineMarkEmailRead } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
const RequestTerminalAccountConfirmationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-100 tw-p-10">
      <h5 className="tw-flex tw-items-center tw-gap-2 tw-text-base tw-font-bold tw-text-red-600 tw-mb-3">
        <FaUserTimes /> Request Submitted!
      </h5>
      <p className="tw-text-sm tw-text-slate-600 tw-mb-6">
        Your request for a terminal account has been successfully submitted to the IT department.
      </p>

      <div className="tw-flex tw-justify-center tw-mb-6">
        <MdOutlineMarkEmailRead className="tw-text-green-500" size={100} />
      </div>

      <div className="tw-flex tw-justify-center">
        <Button variant="primary" onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    </div>
  );
};

export default RequestTerminalAccountConfirmationPage;
